import { render, staticRenderFns } from "./_CompareDayDisplay.vue?vue&type=template&id=2b70efe2"
import script from "./_CompareDayDisplay.vue?vue&type=script&lang=js"
export * from "./_CompareDayDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports